import colorName from 'color-name';

export function suggestHexFromName(name: string): string | null {
  const key = name.trim().toLowerCase();
  const rgb = key ? colorName[key as keyof typeof colorName] : undefined;
  if (!rgb) {
    return null;
  }
  return `#${rgb
    .map((value: number) => value.toString(16).padStart(2, '0'))
    .join('')}`.toUpperCase();
}
